import React,{useState} from 'react'
export default function TexForm(props) {
  const upClick =()=>{
   // console.log("uper case is clicked" + text);
    let newtext=text.toUpperCase();
    setText(newtext);
    props.showAlert("conver to uppercase!","success ")
  }
  const lowClick =()=>{
    let newtext=text.toLowerCase();
    setText(newtext)
    props.showAlert("conver to lowerercase!","success ")
  }
  const clearClick=()=>{
    let blantext="";
    setText(blantext);
    props.showAlert("clear text!","success ")

  }
  const copyClick=()=>{
    var text=document.getElementById("myBox")
    text.select();
    navigator.clipboard.writeText(text.value);
    props.showAlert("copy text!","success ")
  }
const handleOnChange =(hi)=>{
 // console.log(" on change");
  setText(hi.target.value);
}

  const[text,setText] = useState('enter text here');
  return ( 
    <>
    <div className="cointainer" style={{color:props.mode==='dark'?'white':'#042743'}}>
      <h1>{props.heading}</h1>
    <div className="mb-3">
  
  <textarea className="form-control" value={text} onChange={handleOnChange}
   style={{backgroundColor:props.mode==='dark'?'#13466e':'white',color:props.mode==='dark'?'white':'#042743'}} id="myBox" rows="10"></textarea>
</div>
<button className="btn btn-primary mx-2 my-1" onClick={upClick}>convert to Uppercase</button>
<button className="btn btn-primary mx-2 my-1" onClick={lowClick}>convert to Lowercase</button>
<button className="btn btn-primary mx-2 my-1" onClick={clearClick}>clear Text</button>
<button className="btn btn-primary mx-2 my-1" onClick={copyClick}>copy Text</button>
    </div>
    <div className="cointainer " style={{color:props.mode==='dark'?'white':'#042743'}}>
      <h3>your text summary</h3>
      <p>{text.split(/\s+/).filter((element)=>{return element.length!==0}).length} words and {text.length} character</p>
      <p>{0.008 * text.split(" ").filter((element)=>{return element.length!==0}).length} mimits read</p>
      <h3>preview</h3>
      <p>{text}</p>
    </div>
    </>
  )
}
